export default "__VITE_ASSET__ad593ae4__"